module.exports = __webpack_public_path__ + "static/editor-no-console-d78c527578c5144109ce439dc67731a6.jpg";